import React from "react";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div data-testid="dashboard-settings-page">
      <div className="overline text-[var(--lh-mauve)] mb-3">Settings</div>
      <h1 className="font-serif-display text-5xl tracking-tighter leading-[0.95]">Your <em>account.</em></h1>

      <div className="mt-12 grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-[var(--lh-border)] p-8">
          <div className="overline text-[var(--lh-muted)] mb-4">Profile</div>
          <div className="space-y-3 text-sm">
            <div><span className="overline text-[var(--lh-muted)] mr-3">Name</span>{user?.name}</div>
            <div><span className="overline text-[var(--lh-muted)] mr-3">Email</span>{user?.email}</div>
            <div><span className="overline text-[var(--lh-muted)] mr-3">Role</span>{user?.role || "member"}</div>
            <div><span className="overline text-[var(--lh-muted)] mr-3">Tier</span>{user?.tier || "Free"}</div>
          </div>
        </div>
        <div className="bg-white border border-[var(--lh-border)] p-8">
          <div className="overline text-[var(--lh-muted)] mb-4">Preferences</div>
          <p className="text-sm text-[var(--lh-text)] font-light">
            Notification and communication preferences are coming soon. For account changes, email{" "}
            <a href="mailto:hello@localizeher.com" className="text-[var(--lh-mauve)]">hello@localizeher.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
